import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useConfig() {
  const q = useQuery({ queryKey: ["config"], queryFn: async () => (await api.get("/config")).data, staleTime: 5 * 60_000 });
  return { config: q.data, ...q };
}
